'use client'

import { SearchBar } from '@/components/shared/search-bar'
import { SignInButton } from '@/components/shared/sign-in-button'
import { Button } from '@/components/ui/button'
import { isMarketplaceEnabled } from '@/lib/flags'
import { getApiUrl } from '@/lib/utils'
import { useQuery } from '@tanstack/react-query'
import { motion } from 'motion/react'
import Link from 'next/link'
import { SiGithub } from 'react-icons/si'

const GITHUB_REPO = process.env.NEXT_PUBLIC_GITHUB_REPOSITORY

export function NavbarActions() {
  type StarsResponse = {
    stars: string
  }

  async function fetchGitHubStars() {
    const response = await fetch(getApiUrl('/api/github/stars'))
    if (!response.ok) {
      throw new Error('Failed to fetch GitHub stars')
    }
    return response.json() as Promise<StarsResponse>
  }

  const { data } = useQuery({
    queryKey: ['github-stars'],
    queryFn: fetchGitHubStars,
    staleTime: 1000 * 60 * 60, // 1 hour
    refetchOnWindowFocus: false,
  })

  const stars = data?.stars

  if (!stars) {
    return null
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}
      className="flex items-center gap-4"
    >
      <SearchBar />
      {stars && (
        <Button
          variant="outline"
          asChild
        >
          <Link
            href={`https://github.com/${GITHUB_REPO}`}
            target="_blank"
          >
            <SiGithub /> {stars}k
          </Link>
        </Button>
      )}
      {isMarketplaceEnabled && <SignInButton />}
    </motion.div>
  )
}
